import EditarNomeConfigEnvelope from "./EditarNomeConfigEnvelope";
import TabelaDeConfigEnvelopeDados from "./TabelaDeConfigEnvelopeDados";

interface IDadosConfigEnvelopeProps {}

export default function DadosConfigEnvelope(props: IDadosConfigEnvelopeProps) {
    return (
        <div className="p-4">
            <EditarNomeConfigEnvelope />
            <TabelaDeConfigEnvelopeDados />
        </div>
    );
}
